module.exports = __webpack_public_path__ + "img/football-icon-white.0bfb81d9.png";